import funcTranslateHelper from '../../../i18next/funcTranslateHelper';

export function translateSchema () {
  return {
    type: 'object',
    properties: {
      nombre: {
        title: funcTranslateHelper('Builder:Transitions:form:name'),
        type: 'string',
        placeholder: funcTranslateHelper('Builder:Transitions:form:namePlaceholder')
      },
      id: {
        type: 'string'
      },
      source: {
        type: 'string',
        title: funcTranslateHelper('Builder:Transitions:form:source'),
        default: ''
      },
      destination: {
        type: 'string',
        title: funcTranslateHelper('Builder:Transitions:form:destination'),
        default: ''
      },
      roles: {
        title: funcTranslateHelper('Builder:Transitions:form:roles'),
        type: 'array',
        minItems: 1,
        items: {
          type: 'string',
          enum: [''],
          enumValues: [funcTranslateHelper('Builder:Transitions:form:chooseOption')]
        },
        uniqueItems: true
      },
      actions: {
        type: 'string',
        title: funcTranslateHelper('Builder:Transitions:form:actions'),
        placeholder: funcTranslateHelper('Builder:Transitions:form:actionsPlaceholder')
      },
      isAutomatedTransition: {
        type: 'number',
        title: funcTranslateHelper('Builder:Transitions:form:isAutomatedTransition'),
        enum: [1, 0],
        enumNames: [
          funcTranslateHelper('Builder:Transitions:form:true'),
          funcTranslateHelper('Builder:Transitions:form:false')
        ],
        default: 0
      },
      hasAutomatedTransition: {
        type: 'number',
        title: funcTranslateHelper('Builder:Transitions:form:hasAutomatedTransition'),
        enum: [1, 0],
        enumNames: [funcTranslateHelper('Builder:Transitions:form:true'), funcTranslateHelper('Builder:Transitions:form:false')],
        default: 0
      },
      additionalActions: {
        title: funcTranslateHelper('Builder:Transitions:form:additionalActions'),
        type: 'array',
        items: {
          type: 'string',
          enum: [''],
          enumValues: [funcTranslateHelper('Builder:Transitions:form:chooseOption')]
        },
        uniqueItems: true
      }
    },
    dependencies: {
      hasAutomatedTransition: {
        oneOf: [
          {
            properties: {
              hasAutomatedTransition: {
                enum: [1]
              },
              automatedTransition: {
                type: 'array',
                maxItems: 1,
                items: {
                  type: 'object',
                  properties: {
                    id: {
                      title: funcTranslateHelper('Builder:Transitions:form:autoTransition'),
                      type: 'string',
                      enum: [],
                      enumNames: [],
                      default: ''
                    }
                  }
                }
              }
            }
          },
          {
            properties: {
              hasAutomatedTransition: {
                enum: [0]
              }
            }
          }
        ]
      }
    },
    required: ['nombre', 'source', 'destination', 'roles', 'actions']
  };
}

export const uiSchema = {
  'ui:rootFieldId': 'form-transition',
  nombre: {
    'ui:field': 'TextInput',
    classNames: 'form-control-parent'
  },
  id: {
    'ui:field': 'HiddenId'
  },
  source: {
    classNames: 'form-control-parent',
    'ui:field': 'Select'
  },
  destination: {
    classNames: 'form-control-parent',
    'ui:field': 'Select'
  },
  roles: {
    'ui:field': 'MultiSelect',
    classNames: 'form-control-parent'
  },
  actions: {
    classNames: 'form-control-parent',
    'ui:field': 'Select'
  },
  hasAutomatedTransition: {
    classNames: 'form-control-parent',
    'ui:field': 'Radio'
  },
  isAutomatedTransition: {
    classNames: 'form-control-parent',
    'ui:field': 'Radio'
  },
  automatedTransition: {
    'ui:btnText': 'Añadir datos',
    items: {
      id: {
        'ui:field': 'Select'
      }
    }
  },
  additionalActions: {
    classNames: 'form-control-parent',
    'ui:field': 'MultiSelect'
  },
  'ui:order': ['nombre', 'id', 'source', 'destination', 'roles', 'actions', 'isAutomatedTransition', 'hasAutomatedTransition', '*', 'additionalActions']
};

export function addOptionsToSchema (schema, config) {
  const defaultActions = config.defaultActions || [];

  // add stages
  const { stageNames, stageIds } = config.stages.reduce((acc, stage) => {
    stage.stages.forEach(substage => {
      acc.stageNames.push(stage.name + '.' + substage.name);
      acc.stageIds.push(substage.id);
    });
    return acc;
  }, { stageNames: [], stageIds: [] });
  const sourceStageEnum = ['', 'none'];
  const sourceStageEnumNames = [
    funcTranslateHelper('Builder:Transitions:form:chooseSource'),
    funcTranslateHelper('Builder:Transitions:form:none')
  ];

  schema.properties.source.enum = sourceStageEnum.concat(stageIds);
  schema.properties.source.enumNames = sourceStageEnumNames.concat(stageNames);
  schema.properties.destination.enumNames = [funcTranslateHelper('Builder:Transitions:form:chooseDestiny')].concat(stageNames);
  schema.properties.destination.enum = [''].concat(stageIds);

  // add actions
  schema.properties.actions.enum = [''].concat(config.actions.map(e => e.id));
  schema.properties.actions.enumNames = [funcTranslateHelper('Builder:Transitions:form:chooseOption')]
    .concat(config.actions.map(e => e.name));

  // add additional actions
  if (defaultActions.length) {
    // Additional (optional) actions
    schema.properties.additionalActions.items.enumValues = defaultActions.filter(e => e.id !== 'expiration')
      .map(e => funcTranslateHelper(`Builder:Transitions:form:${e.id}`));
    schema.properties.additionalActions.items.enum = defaultActions.filter(e => e.id !== 'expiration')
      .map(e => e.id);

    // Form options when has an automatic transition
    schema.dependencies.hasAutomatedTransition.oneOf[0].properties
      .automatedTransition.items.properties.id.enum = [''].concat(config.transitions.filter(e => e.isAutomatedTransition).map(e => e.id));
    schema.dependencies.hasAutomatedTransition.oneOf[0].properties
      .automatedTransition.items.properties.id.enumNames = [funcTranslateHelper('common:Builder:Transitions:form:chooseOption')]
        .concat(config.transitions.filter(e => e.isAutomatedTransition).map(e => e.nombre));
  } else {
    delete schema.properties.additionalActions;
    delete schema.dependencies;
    delete schema.properties.isAutomatedTransition;
    delete schema.properties.hasAutomatedTransition;
  }

  // add roles
  schema.properties.roles.items.enum = config.roles.map(role => role.name);
  schema.properties.roles.items.enumValues = config.roles.map(role => role.name);
}
